import { render, staticRenderFns } from "./codeAbout.vue?vue&type=template&id=5dae5408&scoped=true"
import script from "./codeAbout.vue?vue&type=script&lang=js"
export * from "./codeAbout.vue?vue&type=script&lang=js"
import style0 from "./codeAbout.vue?vue&type=style&index=0&id=5dae5408&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dae5408",
  null
  
)

export default component.exports